<div class="nav-filter">
  <div class="position-relative">
    <input type="text" id="nav_filter_input" placeholder="{{'Filter menu' | i18next}}" class="form-control" tabindex="0">
    <a href="#" onclick="return false;" class="btn-primary btn-search-close js-waves-off" data-action="toggle" data-class="list-filter-active" data-target=".page-sidebar">
      <i class="{{iconPrefix}} fa-chevron-up"></i>
    </a>
  </div>
</div>
